var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FFB800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9252 20.9055C12.6302 20.9055 10.8808 19.5723 10.864 19.5555C10.4477 19.2405 10.369 18.6386 10.684 18.2167C10.864 17.9805 11.1452 17.8398 11.4433 17.8398C11.6515 17.8398 11.8596 17.9073 12.0227 18.0367C12.0733 18.0705 13.3221 19.0042 14.8858 19.0042C15.7971 19.0042 16.6465 18.6892 17.4059 18.0592C17.5746 17.9186 17.794 17.8398 18.0134 17.8398C18.3002 17.8398 18.5702 17.9692 18.7502 18.1886C19.0877 18.5992 19.0259 19.2011 18.6209 19.5386C17.5184 20.4442 16.2752 20.9055 14.9252 20.9055Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4433 18.4023C11.5277 18.4023 11.6121 18.4305 11.6796 18.4811C11.7639 18.543 13.1364 19.5611 14.8858 19.5611C15.7858 19.5611 16.7871 19.2911 17.7658 18.4867C17.8389 18.4248 17.9289 18.3967 18.0133 18.3967C18.1258 18.3967 18.2383 18.4473 18.3171 18.543C18.4577 18.7117 18.4296 18.9592 18.2608 19.0998C17.1302 20.028 15.9658 20.3373 14.9196 20.3373C12.8439 20.3373 11.2239 19.128 11.2014 19.1055C11.0271 18.9761 10.9933 18.7286 11.1283 18.5542C11.2071 18.4586 11.3252 18.4023 11.4433 18.4023ZM11.4433 17.2773C10.9708 17.2773 10.5208 17.5023 10.2339 17.8792C9.72768 18.543 9.85706 19.4992 10.5208 20.0055C10.5377 20.0167 12.4389 21.468 14.9252 21.468C16.4102 21.468 17.7771 20.9673 18.9808 19.9717C19.6277 19.443 19.7233 18.4811 19.1889 17.8342C18.8964 17.4798 18.4689 17.2773 18.0133 17.2773C17.6646 17.2773 17.3214 17.4011 17.0514 17.6205C16.3821 18.1717 15.6733 18.4361 14.8858 18.4361C13.5077 18.4361 12.3658 17.5867 12.3546 17.5811C12.1014 17.3898 11.7752 17.2773 11.4433 17.2773Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15398 17.4237C9.75356 17.4237 10.2396 16.7413 10.2396 15.8994C10.2396 15.0575 9.75356 14.375 9.15398 14.375C8.55441 14.375 8.06836 15.0575 8.06836 15.8994C8.06836 16.7413 8.55441 17.4237 9.15398 17.4237Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3088 17.4237C20.9083 17.4237 21.3944 16.7413 21.3944 15.8994C21.3944 15.0575 20.9083 14.375 20.3088 14.375C19.7092 14.375 19.2231 15.0575 19.2231 15.8994C19.2231 16.7413 19.7092 17.4237 20.3088 17.4237Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L10.24 12.3106",
    stroke: "black",
    strokeWidth: 0.7875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4573 11L19.2173 12.3106",
    stroke: "black",
    strokeWidth: 0.7875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile1);
export default __webpack_public_path__ + "static/media/profile1.92f1603f20ae184aafa0d8d02c3eb0da.svg";
export { ForwardRef as ReactComponent };